import React from 'react';
import { Star } from 'lucide-react';
import { Reveal, EstimateBanner } from '../components/shared';
import { PageHeader } from './Flooring';
import { reviews } from '../mock/mock';

export default function Reviews() {
  return (
    <>
      <PageHeader
        eyebrow="Reviews"
        title="What our customers say"
        sub="Real feedback from homeowners across the region who let us bring the showroom to them."
        image="https://images.unsplash.com/photo-1560449752-3fd4bdbe7df0?auto=format&fit=crop&w=1920&q=80"
      />

      <section className="max-w-7xl mx-auto px-6 py-16 md:py-20">
        <Reveal>
          <div className="bg-white rounded-2xl border border-brand-line shadow-sm p-8 md:p-10 flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
            <div>
              <h2 className="font-display text-2xl md:text-3xl font-semibold text-brand-charcoal">Rated 4.9 out of 5</h2>
              <p className="text-brand-stone mt-2">Based on 200+ verified Google &amp; Facebook reviews</p>
            </div>
            <div className="flex items-center gap-4">
              <span className="font-display text-6xl font-semibold text-brand-clay">4.9</span>
              <div className="flex text-brand-clay">{[...Array(5)].map((_, k) => <Star key={k} size={22} fill="currentColor" />)}</div>
            </div>
          </div>
        </Reveal>

        <div className="mt-10 columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {reviews.map((r, idx) => (
            <Reveal key={r.name} delay={(idx % 3) * 80}>
              <div className="break-inside-avoid bg-white rounded-2xl p-7 border border-brand-line shadow-sm">
                <div className="flex text-brand-clay mb-4">{[...Array(r.rating)].map((_, k) => <Star key={k} size={16} fill="currentColor" />)}</div>
                <p className="text-brand-charcoal/85 leading-relaxed text-[15px]">“{r.text}”</p>
                <div className="mt-5 flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-brand-cream text-brand-clay font-semibold flex items-center justify-center">{r.name[0]}</span>
                  <div>
                    <p className="font-semibold text-brand-charcoal leading-tight">{r.name}</p>
                    <p className="text-xs text-brand-stone">Verified customer</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <EstimateBanner />
    </>
  );
}
